import get from 'lodash/get';
import {
  getFormattedAverage,
  selectAverageData,
  selectDifferenceData,
  selectMedianData,
  selectMedianDifferenceData
} from '../../../../../utils';

export const getPositiveCounters = (rows, columns, TABLE_CONSTANTS) => {
  const counts = {};
  const headerIndexes = get(TABLE_CONSTANTS, 'POSITIVE_COLUMNS_TO_COUNT', []);
  columns.forEach((_, index) => {
    if (headerIndexes.includes(index)) {
      counts[`answer_${index - 1}`] = 0;
    }
  });

  rows.forEach(student => {
    columns.forEach((_, index) => {
      if (headerIndexes.includes(index)) {
        const answerKey = `answer_${index - 1}`;
        if (student[answerKey] === 'Yes') {
          counts[answerKey]++;
        }
      }
    });
  });

  return counts;
};

export const getConfidenceHeaders = (insightsData, TABLE_CONSTANTS) => {
  const headers = {};
  const currentIndex = TABLE_CONSTANTS.CONFIDENCE_COLUMN_IDX ||
    TABLE_CONSTANTS.CONFIDENCE_CURRENT_COLUMN_IDX;
  const changeIndex = TABLE_CONSTANTS.CONFIDENCE_CHANGE_COLUMN_IDX;

  if (currentIndex) {
    const averageData = selectAverageData(insightsData);
    const average = getFormattedAverage(parseFloat(averageData.average), 1);
    const maxValue = averageData.max_value || 5;

    headers[`answer_${currentIndex - 1}`] = {
      average,
      maxValue,
    };
  }

  if (changeIndex) {
    const changeData = selectDifferenceData(insightsData);
    const changeValue = parseFloat(changeData.this_assignment) - parseFloat(changeData.last_assignment);

    const change = getFormattedAverage(changeValue, 1);
    headers[`answer_${changeIndex - 1}`] = {
      change,
    };
  }

  return headers;
};

export const getHourHeaders = (insightsData, TABLE_CONSTANTS) => {
  const headers = {};
  const hoursIndex = TABLE_CONSTANTS.TOTAL_HOURS_COLUMN_IDX;
  const hoursChangeIndex = TABLE_CONSTANTS.HOURS_CHANGE_COLUMN_IDX;
  if (hoursIndex) {
    const average = selectMedianData(insightsData);
    const median = getFormattedAverage(parseFloat(average.median), 1);
    headers[`answer_${hoursIndex - 1}`] = {
      median
    };
  }
  if (hoursChangeIndex) {
    const hoursChangeData = selectMedianDifferenceData(insightsData);
    const changeValue = parseFloat(hoursChangeData.this_assignment) - parseFloat(hoursChangeData.last_assignment);
    const change = getFormattedAverage(parseFloat(changeValue), 1);
    headers[`answer_${hoursChangeIndex - 1}`] = {
      change
    };
  }
  return headers;
};
